import api from '@/helpers/api'

export const getMenu = () => api.get('/api/config/menu/get').then((response) => response.data)

export const updateMenu = (menu) => api.put('/api/config/menu/update', {
    menu
})
